import styled from 'styled-components';

export const CategoryItem = styled.p<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  margin: 0;
  width: 100%;
  height: 40px;
  padding: 0 20px;
  cursor: pointer;
  font-size: 16px;
  color: var(--gray_900);
  background: ${({ isSelected }) => (isSelected ? 'var(--gray_20)' : '#fff')};
  &:hover {
    background: rgba(48, 174, 242, 0.2);
  }
`;

export const ListContent = styled.div`
  width: 420px;
  max-height: 190px;
  border-radius: 5px;
  overflow-y: auto;
`;
